import type { State } from './vuex';

export default {
  hasActiveRegistration(state: State): boolean {
    return state.activeRegistrations.length > 0;
  },
};
